export const THEMATIC_STUDIES_VIEW_PARAM = 'view';
export const THEMATIC_STUDIES_VIEW_STORAGE_KEY = 'thematicStudies.viewMode';

export type ThematicStudiesViewMode = 'themes' | 'all';

export function normalizeThematicStudiesViewMode(value: string | null): ThematicStudiesViewMode {
    return value === 'all' ? 'all' : 'themes';
}

export function getStoredThematicStudiesViewMode(): ThematicStudiesViewMode | null {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        const storedValue = window.localStorage.getItem(THEMATIC_STUDIES_VIEW_STORAGE_KEY);
        if (!storedValue) {
            return null;
        }

        return storedValue === 'all' ? 'all' : 'themes';
    } catch {
        return null;
    }
}

export function resolveThematicStudiesViewMode(urlValue: string | null): ThematicStudiesViewMode {
    if (urlValue === 'all' || urlValue === 'themes') {
        return urlValue;
    }

    return getStoredThematicStudiesViewMode() ?? 'themes';
}

export function persistThematicStudiesViewMode(viewMode: ThematicStudiesViewMode): void {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        window.localStorage.setItem(THEMATIC_STUDIES_VIEW_STORAGE_KEY, viewMode);
    } catch {
        // Intentionally ignored to avoid runtime errors in restricted environments.
    }
}
